import React, { useEffect, useState } from 'react';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import Header from '../header/Header';
import Grid from '@mui/material/Grid';
import Autocomplete from '@mui/material/Autocomplete';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import { API_URL } from '../../Constants';


function ViabilityStudy() {

    let apiUrl = API_URL;

    const ButtonPrincipal = styled(Button)({
        flexGrow: 0,
        borderRadius: '20px',
        gap: '10px',
        backgroundColor: '#161e55',
        '&:hover': {
            backgroundColor: '#A8C8AF',
        },
    });

    const bucketTypes = [
        { label: 'Al día', value: 'UP_TO_DATE' },
        { label: 'Treinta (30)', value: 'THIRTY' },
        { label: 'Sesenta (60)', value: 'SIXTY' },
        { label: 'Noventa (90)', value: 'NINETY' }
    ];


    const handleOnClickViabilityForm = () => {
        let paymentIndicator = document.getElementById("paymentIndicator").value;
        let estimatedIncome = document.getElementById("estimatedIncome").value;
        let utilizationPercentage = document.getElementById("utilizationPercentage").value;
        const bucket = bucketTypes.find(res => res.label === document.getElementById("bucket").value).value;
        let clientUuid = localStorage.getItem('clientUuid');
        let feasibilityUuid = localStorage.getItem('feasibilityUuid');
        console.log(paymentIndicator);
        console.log(estimatedIncome);
        console.log(utilizationPercentage);
        console.log(bucket);
        console.log(clientUuid);
        if (paymentIndicator === "" || estimatedIncome === "" || utilizationPercentage === "" || bucket === "") {
            alert("Revisa los campos obligatorios")
        } else {
            let study = {
                paymentIndicator: paymentIndicator,
                estimatedIncome: estimatedIncome,
                utilizationPercentage: utilizationPercentage,
                bucket: bucket,
                clientUuid: clientUuid,
                feasibilityInquiryUuid: feasibilityUuid
            }
            createViabilityStudy(study)
        }
    }

    const createViabilityStudy = (study) => {
        fetch(apiUrl + '/v1/viability-studies', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json ',
                'Accept': 'application/json',
            },
            body: JSON.stringify(study),
        }).then(function (response) {
            if (response.ok) {
                response.json().then(function (res) {
                    window.location = '/general-admin';
                });
            }
        }).catch(function (error) {
            console.log('Hubo un problema con la petición Fetch:' + error.message);
        });
    }

    const handleBackToHome = () => {
        window.location = '/pending-viabilities';
    }
    return (
        <React.Fragment> <Header />
            <Container maxWidth="md">
                <br />
                <br />
                <br />
                <Box sx={{ flexGrow: 1 }}>
                    <Grid container spacing={3}>
                        <Grid item xs />
                        <Grid item xs={6}>
                            <Stack spacing={4.5}>
                                <TextField required id="paymentIndicator" label="Indicador de pago / Score" variant="outlined" />
                                <TextField required id="estimatedIncome" label="Ingresos estimados" variant="outlined" />
                                <TextField id="utilizationPercentage" label="Porcentaje de utilización" variant="outlined" />
                                <Autocomplete
                                    disablePortal
                                    id="bucket"
                                    options={bucketTypes}
                                    defaultValue={bucketTypes[0]}
                                    renderInput={(params) => <TextField {...params} required label="Bucket" />}
                                />
                                <Stack spacing={2} direction="row">
                                    <ButtonPrincipal variant="contained" onClick={handleBackToHome}>Volver</ButtonPrincipal>
                                    <ButtonPrincipal variant="contained" onClick={handleOnClickViabilityForm}>Enviar datos</ButtonPrincipal>
                                </Stack>

                            </Stack>
                        </Grid>
                        <Grid item xs />
                    </Grid>
                </Box>
            </Container>
        </React.Fragment>
    );
}

export default ViabilityStudy;